module.exports = __webpack_public_path__ + "img/logohome.468028d6.png";